const device = require("_js/device.js");
const sys = require("_js/sys.js");
const ua = require("_js/useragent.js");
const messages = require("_js/messages.js");

const html5 = {
	init: init,
	requestFullscreen: requestFullscreen,
	toggleOrientationMessage: toggleOrientationMessage,
	disableMobileFullscreen: disableMobileFullscreen
};

module.exports = html5;

let iframe_interval;
let is_disabled_fullscreen = false;
let fulscreen_dom;

function init() {
	if (!ua.isDesktop) {
		// iphone 5: to prevent status bar to appear
		document.body.innerHTML = `${document.body.innerHTML}<div id="gl-overlay"><div class="hand"></div></div>`;
	}

	const disable_ios_fs = sys.params.game.disable_ios_fs || sys.params.disable_ios_fs;

	device.init(sys.params.game.use_nosleep, disable_ios_fs);

	if (!ua.isDesktop) {
		initOrientationListeners();
		onResize();
	}

	// set correct viewport
	setViewport();

	initWheel();

	iframe_interval = setInterval(fixIframe, 100);
}

function setViewport() {
	const viewport = "height=device-height, width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, "
		+ "user-scalable=no, minimal-ui";
	const el = document.getElementsByName("viewport")[0];
	if (el) {
		el.setAttribute("content", viewport);
	} else {
		const metaTag = document.createElement("meta");
		metaTag.name = "viewport";
		metaTag.content = viewport;
		document.getElementsByTagName("head")[0].appendChild(metaTag);
	}
}

function initOrientationListeners() {
	window.addEventListener("orientationchange", onOrientationChange, false);
	window.addEventListener("resize", onResize, false);
	if (sys.params.game.position === 2) {
		initPortraitMessage();
	} else if (sys.params.game.position === 3) {
		initLandscapeMessage();
	}
	if (ua.isFirefox) {
		window.addEventListener("deviceorientation", onOrientationChange);
	}
}

function onOrientationChange() {
	toggleOrientationMessage();
}

function onResize() {
	toggleOrientationMessage();
}

function fixIframe() {
	try {
		if (window.top.location.hostname !== window.self.location.hostname) {
			clearInterval();

			return;
		}

		const is_no_need_fix = Boolean(sys.params.isNoNeedFixCanvas);

		if (window.self === window.top || is_no_need_fix) {
			clearInterval(iframe_interval);

			return;
		}

		const canvas = document.getElementsByTagName("canvas")[0];

		if (canvas && canvas.style) {
			if (canvas.style.position !== "fixed") {
				canvas.style.position = "fixed";
				clearInterval(iframe_interval);
			}
		}
	} catch (err) {
		clearInterval(iframe_interval);

		return;
	}
}

function toggleOrientationMessage() {
	if (ua.isDesktop) return;

	if (sys.params.game.position === 2) {
		togglePortraitMessage();
	} else if (sys.params.game.position === 3) {
		toggleLandscapeMessage();
	}
}

function togglePortraitMessage() {
	const prt = document.getElementById("portrait-message");
	const ldr = document.getElementById("loader-wrapper");
	const gc = document.getElementById("game-content");

	if (device.getOrientation() === "portrait") {
		device.disableCheckFS();
		prt.style.display = "block";
		ldr.style.display = "block";
		gc.style.display = "none";
	} else {
		device.enableCheckFS();
		prt.style.display = "none";
		ldr.style.display = "none";
		gc.style.display = "block";
	}
}

function toggleLandscapeMessage() {
	const prt = document.getElementById("portrait-message");
	const ldr = document.getElementById("loader-wrapper");
	const gc = document.getElementById("game-content");

	if (device.getOrientation() === "landscape") {
		device.disableCheckFS();
		prt.style.display = "block";
		ldr.style.display = "block";
		gc.style.display = "none";
	} else {
		device.enableCheckFS();
		prt.style.display = "none";
		ldr.style.display = "none";
		gc.style.display = "block";
	}
}

function initPortraitMessage() {
	const lang = sys.params.language;
	const msgs = sys.params.portrait_message || messages.getMessages("portrait", lang);

	document.body.innerHTML = `${""
		+ "<div id=\"loader-wrapper\">"
		+ "   <div id=\"portrait-message\">"
		+ "       <div class=\"portrait-game-logo portraitLogoDiv\"></div>"
		+ "       <div class=\"iphone_outline_uri phoneOutlineDiv-portrait\"></div>"
		+ "       <div id=\"rotateanim-portrait\" class=\"iphone_outline_uri rotatingPhoneDiv\"></div>"
		+ "       <div class=\"portrait-message-text\"></div>"
		+ `       <div class=\"portrait-or\">${msgs.or}</div>`
		+ `       <div class=\"portrait-link\"><a href=${sys.params.home_page}>${msgs.back}</a></div>`
		+ "   </div>"
		+ "</div>"
		+ "\n"}${document.body.innerHTML}`;

	const logoUrl = `url(${sys.params.path}${sys.params.game.preview})`;
	document.getElementsByClassName("portrait-game-logo")[0].style.backgroundImage = logoUrl;
	document.getElementsByClassName("portrait-message-text")[0].innerHTML = msgs.turn;
}

function initLandscapeMessage() {
	const lang = sys.params.language;
	const msgs = sys.params.landscape_message || messages.getMessages("landscape", lang);

	document.body.innerHTML = `${""
		+ "<div id=\"loader-wrapper\">"
		+ "   <div id=\"portrait-message\">"
		+ "       <div class=\"landscape-bg\"></div>"
		+ "       <div class=\"landscape-game-logo landscapeLogoDiv\"></div>"
		+ "       <div class=\"iphone_outline_uri phoneOutlineDiv-landscape\"></div>"
		+ "       <div id=\"rotateanim-landscape\" class=\"iphone_outline_uri rotatingPhoneDiv\"></div>"
		+ "       <div class=\"landscape-message-text\"></div>"
		+ `       <div class=\"landscape-or\">${msgs.or}</div>`
		+ `       <div class=\"landscape-link\"><a href=${sys.params.home_page}>${msgs.back}</a></div>`
		+ "   </div>"
		+ "</div>"
		+ "\n"}${document.body.innerHTML}`;

	const logoUrl = `url(${sys.params.path}${sys.params.game.preview})`;
	document.getElementsByClassName("landscape-game-logo")[0].style.backgroundImage = logoUrl;
	document.getElementsByClassName("landscape-message-text")[0].innerHTML = msgs.turn;
}

function isFullscreenAllowed() {
	const disable_fs = sys.params.game.disable_fs || sys.params.disable_fs || is_disabled_fullscreen;

	return !disable_fs && !ua.isDesktop && ua.isAndroid;
}

function launchIntoFullscreen(element = document.getElementById("game-content")) {
	if (element.requestFullscreen) {
		element.requestFullscreen({navigationUI: "hide"});
	} else if (element.mozRequestFullScreen) {
		element.mozRequestFullScreen();
	} else if (element.webkitRequestFullscreen) {
		element.webkitRequestFullscreen();
	} else if (element.msRequestFullscreen) {
		element.msRequestFullscreen();
	}
}

function leaveFullscreen(element = document.getElementById("game-content")) {
	if (element.cancelFullscreen) {
		element.cancelFullscreen();
	} else if (element.mozCancelFullScreen) {
		element.mozCancelFullScreen();
	} else if (element.webkitCancelFullScreen) {
		element.webkitCancelFullScreen();
	} else if (element.msRequestFullscreen) {
		element.msCancelFullScreen();
	}

	if (document.fullscreenElement) {
		document.exitFullscreen();
	}
}

function disableMobileFullscreen() {
	if (is_disabled_fullscreen) {
		return;
	}

	is_disabled_fullscreen = true;

	removeFulscreenDom();
	leaveFullscreen();

	device.disableIOSFS();
}

function requestFullscreen() {
	if (!isFullscreenAllowed()) {
		return;
	}

	if (
		document.fullscreenEnabled
		|| document.webkitFullscreenEnabled
		|| document.mozFullScreenEnabled
		|| document.msFullscreenEnabled
	) {
		fulscreen_dom = document.createElement("DIV");
		fulscreen_dom.id = "full-screen-handler";
		fulscreen_dom.style.position = "absolute";
		fulscreen_dom.style.top = 0;
		fulscreen_dom.style.left = 0;
		fulscreen_dom.style.width = "100%";
		fulscreen_dom.style.height = "100%";
		document.body.appendChild(fulscreen_dom);

		fulscreen_dom.addEventListener("click", () => {
			try {
				removeFulscreenDom();
				launchIntoFullscreen(document.getElementById("game-content"));
			} catch (e) {
				window.scrollTo(0, 1);
			}
		});
	} else {
		window.scrollTo(0, 1);
	}
}

function removeFulscreenDom() {
	if (!fulscreen_dom) {
		return;
	}

	fulscreen_dom.parentNode.removeChild(fulscreen_dom);
	fulscreen_dom = null;
}

function initWheel() {
	if (ua.isDesktop) {
		document.getElementById("game-content").addEventListener("wheel", (event) => {
			event.preventDefault();
		});
	}
}



// WEBPACK FOOTER //
// ./js/html5.js